import { render, staticRenderFns } from "./EditClinicDocument.vue?vue&type=template&id=0dbf940e"
import script from "./EditClinicDocument.vue?vue&type=script&lang=js"
export * from "./EditClinicDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports